module.exports = __webpack_public_path__ + "static/media/Img_4.0f45096c.jpg";